/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { SiteService } from './SiteService';

class SiteServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new SiteService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { SiteServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/SiteServiceProvider.js